// Copyright © 2021 Move Closer
import { Color } from '../../_contracts';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export var NewsBarColor;
(function (NewsBarColor) {
    NewsBarColor[NewsBarColor["Black"] = Color.Black] = "Black";
    NewsBarColor[NewsBarColor["Blue"] = Color.Blue] = "Blue";
    NewsBarColor[NewsBarColor["Brand"] = Color.Brand] = "Brand";
    NewsBarColor[NewsBarColor["Gray"] = Color.Gray] = "Gray";
    NewsBarColor[NewsBarColor["Green"] = Color.Green] = "Green";
    NewsBarColor[NewsBarColor["Custom"] = Color.Custom] = "Custom";
})(NewsBarColor || (NewsBarColor = {}));
/**
 * This enum is needed for better TypeScript experience
 * within the `NewsBar.stories.ts` file.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 *
 * @see ./NewsBar.stories.ts
 */
export var NewsBarPropNames;
(function (NewsBarPropNames) {
    NewsBarPropNames["Closable"] = "closable";
    NewsBarPropNames["Color"] = "color";
})(NewsBarPropNames || (NewsBarPropNames = {}));
